import { XMarkIcon } from "@heroicons/react/16/solid";
import { cn } from "@moe/priv/utils";
import { useAppContext } from "@web/route-services/root/AppContext";

interface TagChipProps {
  tag: string;
  onSelect?: (tag: string) => void;
  isSelected?: boolean;
  clearable?: boolean;
  doHover?: boolean;
  className?: string;
}

export function TagChip({ tag, onSelect, doHover = true, isSelected, clearable, className = "" }: TagChipProps) {
  const spanStyles = `text-tx-tertiary bg-moe-card-tag
  border-moe-card-tag-line rounded-sm px-2.5 py-1
  text-2xs md:text-xs font-mono font-medium whitespace-nowrap h-fit w-fit
  flex items-center gap-1.5`;

  const hoverStyles = `cursor-pointer
  hover:text-tx-primary
  hover:font-semibold`;

  // Larger mobile hitbox
  const buttonStyles = `md:p-0 md:m-0 touch-manipulation p-2 -m-2`;
  const selectedStyles = "bg-action-primary font-semibold text-tx-primary hover:bg-action-primary-hover";

  let styles = spanStyles;
  if (isSelected) {
    styles = cn(styles, selectedStyles);
  } else if (doHover) {
    styles = cn(styles, hoverStyles);
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onSelect?.(tag);
  };

  return (
    <button onClick={handleClick} className={cn(buttonStyles, className)}>
      <span className={styles}>
        {tag}
        {clearable && (
          <XMarkIcon className="hover:text-tx-primary text-tx-tertiary size-4 transition-colors duration-200" />
        )}
      </span>
    </button>
  );
}
